import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ApplicationService } from "../../../services/application.service";

@Component({
  selector: "app-screen-404",
  templateUrl: "./404.html",
  styleUrls: ["./404.less"],
})
export class Error_404Component {
  public constructor(public readonly applicationService: ApplicationService, public readonly translateService: TranslateService) {
    this.applicationService.updateTitle("Oops!");
  }
}
